// extracted by mini-css-extract-plugin
export default {"renderer":"gIHWu"};